import { render, staticRenderFns } from "./CampaignTagFormData.vue?vue&type=template&id=cba29ed8&scoped=true"
import script from "./CampaignTagFormData.vue?vue&type=script&lang=js"
export * from "./CampaignTagFormData.vue?vue&type=script&lang=js"
import style0 from "./CampaignTagFormData.vue?vue&type=style&index=0&id=cba29ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba29ed8",
  null
  
)

export default component.exports